const getImageUrl = (path) => {
	return `${import.meta.env.VITE_IMAGE_URL}/${path}`;
};

export default getImageUrl;
